<template>
  <div>
    <Echart
      :options="options"
      id="centreLeft1Chart"
      height="480px"
      width="100%"
    ></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart'
export default {
  data() {
    return {
      options: {},
      // 定义颜色
      colorList: {
        linearYtoG: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 1,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: '#f5b44d'
            },
            {
              offset: 1,
              color: '#28f8de'
            }
          ]
        },
        linearGtoB: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            {
              offset: 0,
              color: '#43dfa2'
            },
            {
              offset: 1,
              color: '#28f8de'
            }
          ]
        },
        linearGtoB01: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            {
              offset: 0,
              // color: '#43dfa2'
              color: '#0033ff'
            },
            {
              offset: 1,
              color: '#0033ff'
            }
          ]
        },
        linearBtoG: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            {
              offset: 0,
              color: '#1c98e8'
            },
            {
              offset: 1,
              color: '#28f8de'
            }
          ]
        },
        areaBtoG: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: 'rgba(35,184,210,.2)'
            },
            {
              offset: 1,
              color: 'rgba(35,184,210,0)'
            }
          ]
        }
      }
    }
  },
  components: {
    Echart
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    cdata: {
      handler(newData) {
        var indicatorMaxData = newData.maxDataArr[0]; //(newData.maxDataArr[0] > 100 ? 100 : newData.maxDataArr[0]);
        
        this.options = {
          title: {
            text: newData.sensorYText,
            textStyle: {
              color: '#D3D6DD',
              fontSize: 16,
              // fontSize: 12,
              fontWeight: 'normal'
            },
            // subtext: newData.year + '/' + newData.timeCategory[6],
            // subtextStyle: {
            //   color: '#fff',
            //   fontSize: 16
            // },
            top: 250,
            left: 80
          },
          legend: {
            top: 120,
            left: 80,
            orient: 'vertical',
            itemGap: 15,
            itemWidth: 12,
            itemHeight: 12,
            data: ['营养指数', '水温', '水位'],
            textStyle: {
              color: '#fff',
              fontSize: 17,
              // fontSize: 14,
            }
          },
          tooltip: {
            trigger: 'item'
          },
          radar: {
            center: ['68%', '27%'],
            radius: '40%',
            name: {
              color: '#fff',
              fontSize:17,
            },
            splitNumber: 8,
            axisLine: {
              lineStyle: {
                color: this.colorList.linearYtoG,
                opacity: 0.6
              }
            },
            splitLine: {
              lineStyle: {
                color: this.colorList.linearYtoG,
                opacity: 0.6
              }
            },
            splitArea: {
              areaStyle: {
                color: '#fff',
                opacity: 0.1,
                shadowBlur: 25,
                shadowColor: '#000',
                shadowOffsetX: 0,
                shadowOffsetY: 5
              }
            },
            indicator: [
              {
                name: '营养指数',
                // max: indicatorMaxData
                max: 100
                // max: newData.maxData
              },
              {
                name: '水温',
                // max: newData.maxDataArr[1]
                max: 100
              },
              {
                name: '水位',
                // max: newData.maxDataArr[2]
                max: 100
              }
            ]
          },
          grid: {
            left: 90,
            right: 80,
            bottom: 40,
            top: '60%'
          },
          xAxis: {
            type: 'category',
            position: 'bottom',
            axisLine: true,
            axisLabel: {
              color: 'rgba(255,255,255,.8)',
              fontSize: 12
            },
            data: newData.timeCategory
          },
          // 下方Y轴
          yAxis: {
            name: '',
            nameLocation: 'end',
            nameGap: 24,
            nameTextStyle: {
              color: 'rgba(255,255,255,.5)',
              fontSize: 14
            },
            max: newData.maxData,
            splitNumber: 4,

            axisLine: {
              lineStyle: {
                opacity: 0
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#fff',
                opacity: 0.1
              }
            },
            axisLabel: {
              color: 'rgba(255,255,255,.8)',
              fontSize: 12
            }
          },
          series: [
            {
              name: '',
              type: 'radar',
              symbolSize: 0,
              data: [
                {
                  // value:[15, 22, 6,15, 22, 6],
                  value: newData.sensorData[0],
                  name: '营养指数',
                  itemStyle: {
                    normal: {
                      color: '#f8d351',
                      fontSize:16,
                    }
                  },
                  lineStyle: {
                    normal: {
                      opacity: 0
                    }
                  },
                  areaStyle: {
                    normal: {
                      color: '#f8d351',
                      shadowBlur: 25,
                      shadowColor: 'rgba(248,211,81,.3)',
                      shadowOffsetX: 0,
                      shadowOffsetY: -10,
                      opacity: 1
                    }
                  }
                },
                {
                  // value:[33, 28, 40,33, 28, 40],
                  value: newData.sensorData[1],
                  name: '水温',
                  itemStyle: {
                    normal: {
                      color: '#43dfa2',
                      fontSize:16,
                    }
                  },
                  lineStyle: {
                    normal: {
                      opacity: 0
                    }
                  },
                  areaStyle: {
                    normal: {
                      color: this.colorList.linearGtoB,
                      shadowBlur: 15,
                      shadowColor: 'rgba(0,0,0,.2)',
                      shadowOffsetX: 0,
                      shadowOffsetY: 5,
                      opacity: 0.8
                    }
                  }
                },
                {
                  // value:[50, 60, 55,50, 60, 55],
                  value: newData.sensorData[2],
                  name: '水位',
                  itemStyle: {
                    normal: {
                      // color: '#43dfa2'
                      color: '#0033ff',
                      fontSize:16,
                    }
                  },
                  lineStyle: {
                    normal: {
                      opacity: 0
                    }
                  },
                  areaStyle: {
                    normal: {
                      color: this.colorList.linearGtoB01,
                      shadowBlur: 15,
                      shadowColor: 'rgba(0,51,255,1.000)', //'rgba(0,153,255,1.000)', //'rgba(0,0,0,.2)',
                      shadowOffsetX: 0,
                      shadowOffsetY: 5,
                      opacity: 0.8
                    }
                  }
                }
              ]
              // data: [
              //   {
              //     // value: newData.radarDataAvg[6],
              //     value: 33,
              //     name: '营养指数',
              //     itemStyle: {
              //       normal: {
              //         color: '#f8d351'
              //       }
              //     },
              //     lineStyle: {
              //       normal: {
              //         opacity: 0
              //       }
              //     },
              //     areaStyle: {
              //       normal: {
              //         color: '#f8d351',
              //         shadowBlur: 25,
              //         shadowColor: 'rgba(248,211,81,.3)',
              //         shadowOffsetX: 0,
              //         shadowOffsetY: -10,
              //         opacity: 1
              //       }
              //     }
              //   },
              //   {
              //     // value: newData.radarData[6],
              //     value: 53,
              //     name: '水温',
              //     itemStyle: {
              //       normal: {
              //         color: '#43dfa2'
              //       }
              //     },
              //     lineStyle: {
              //       normal: {
              //         opacity: 0
              //       }
              //     },
              //     areaStyle: {
              //       normal: {
              //         color: this.colorList.linearGtoB,
              //         shadowBlur: 15,
              //         shadowColor: 'rgba(0,0,0,.2)',
              //         shadowOffsetX: 0,
              //         shadowOffsetY: 5,
              //         opacity: 0.8
              //       }
              //     }
              //   },
              //   {
              //     // value: newData.radarData[6],
              //     value: 100,
              //     name: '水位',
              //     itemStyle: {
              //       normal: {
              //         color: '#43dfa2'
              //       }
              //     },
              //     lineStyle: {
              //       normal: {
              //         opacity: 0
              //       }
              //     },
              //     areaStyle: {
              //       normal: {
              //         color: this.colorList.linearGtoB,
              //         shadowBlur: 15,
              //         shadowColor: 'rgba(0,0,0,.2)',
              //         shadowOffsetX: 0,
              //         shadowOffsetY: 5,
              //         opacity: 0.8
              //       }
              //     }
              //   }
              // ]
            },
            {
              name: '',
              type: 'line',
              smooth: true,
              symbol: 'emptyCircle',
              symbolSize: 8,
              itemStyle: {
                normal: {
                  color: '#fff'
                }
              },
              lineStyle: {
                normal: {
                  color: this.colorList.linearBtoG,
                  width: 3
                }
              },
              areaStyle: {
                normal: {
                  color: this.colorList.areaBtoG
                }
              },
              data: newData.sensorLineData,
              lineSmooth: true,
              markLine: {
                silent: true,
                data: [
                  {
                    type: 'average',
                    name: '平均值'
                  }
                ],
                precision: 0,
                label: {
                  normal: {
                    formatter: '平均值: \n {c}'
                  }
                },
                lineStyle: {
                  normal: {
                    color: 'rgba(248,211,81,.7)'
                  }
                }
              },
              tooltip: {
                position: 'top',
                // formatter: '{c} m',
                formatter: '{c}',
                backgroundColor: 'rgba(28,152,232,.2)',
                padding: 6
              }
            },
            {
              name: '占位背景',
              type: 'bar',
              itemStyle: {
                normal: {
                  show: true,
                  color: '#000',
                  opacity: 0
                }
              },
              silent: true,
              barWidth: '50%',
              data: newData.sensorMaxData,
              animation: false
            }
          ]
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
